(function() {
  'use strict';

  angular
    .module('app', [
      'ngAnimate',
      'ngMaterial', 
      'ngMessages',
      'ngSanitize',
      'angular-clipboard',
      'LocalStorageModule',
      'ngFileSaver',
      'md.data.table',
      'ui.router',
      
      'app.data',
      'app.debounce',
      'app.dialogs',
      'app.inflector',
      'app.logger',
      'app.metrics',
      'app.plugins',
      'app.settings',
      'app.templates',
      'app.theme',
      'app.validators',
      'app.viewSync',
      
      'app.shell',
      'app.auth',
      'app.poll',
      'app.result',
      'app.myPolls',
      
      'plugins.bar-chart',
      'plugins.free-text-response',
      'plugins.multiple-choice',
      'plugins.word-cloud',
      'plugins.q-and-a'
    ]);
    
})();